import { Icon } from '@iconify/react';
import { useRef, useState } from 'react';
import editFill from '@iconify/icons-eva/edit-fill';
import menu2Fill from '@iconify/icons-eva/menu-2-fill';
import { Link, Link as RouterLink } from 'react-router-dom';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import styled from 'styled-components';
import { 
  Modal, 
  Box, 
  Typography, 
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  TextField,
  Switch,
  FormControlLabel
} from '@mui/material';
import { services } from '../../../services';

// ----------------------------------------------------------------------

export default function UserMoreMenu(props) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [showUserInfo, setShowUserInfo] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editedUserInfo, setEditedUserInfo] = useState(null);

  const handleEditClick = async () => {
    try {
      const response = await services.Get(`/user/user-info/${props.walletAddress}`);
      if (response.status === 200) {
        setUserInfo(response.data.data);
        setEditedUserInfo(response.data.data);
        setShowUserInfo(true);
        setIsEditing(true);
        setIsOpen(false);
      }
    } catch (error) {
      console.error('Error fetching user details:', error);
    }
  };

  const handleViewDetails = async () => {
    try {
      const response = await services.Get(`/user/user-info/${props.walletAddress}`);
      if (response.status === 200) {
        setUserInfo(response.data.data);
        setEditedUserInfo(response.data.data); // Initialize editedUserInfo
        setShowUserInfo(true);
        setIsOpen(false);
      }
    } catch (error) {
      console.error('Error fetching user details:', error);
    }
  };


  const handleUpdate = async () => {
    try {
      const response = await services.Put(`/user/update/${props.walletAddress}`, {
        name: editedUserInfo.name,
        email: editedUserInfo.email,
        country: editedUserInfo.country,
        state: editedUserInfo.state,
        isActive: editedUserInfo.isActive,
        activeStaker: editedUserInfo.activeStaker,
        totalbalance: editedUserInfo.totalbalance,
        kycStatus: editedUserInfo.kycStatus,
        tier: editedUserInfo.tier,
        profilePics: editedUserInfo.profilePics,
        notifyMe: editedUserInfo.notifyMe,
        recordId: editedUserInfo.recordId,
        old_recordId: editedUserInfo.recordId
      });
      
      if (response.status === 200) {
        setUserInfo(editedUserInfo);
        setIsEditing(false);
        handleViewDetails(); // Refresh the data
      }
    } catch (error) {
      console.error('Error updating user:', error);
    }
  };

  // Update the handleDelete function
  const handleDelete = async () => {
    try {
      const response = await services.Delete(`/user/delete-User/${props.walletAddress}`);
      console.log('Delete response:', response);
      if (response.status === 200) {
        setIsOpen(false);
        if (props.onDelete) {
          props.onDelete();
        }
      }
    } catch (error) {
      console.error('Error deleting user:', error);
    }
  };

  // Remove this duplicate function
  // const handleEditClick = async () => {
  //   try {
  //     const response = await services.Get(`/user/user-info/${props.walletAddress}`);
  //     if (response.status === 200) {
  //       setUserInfo(response.data.data);
  //       setEditedUserInfo(response.data.data);
  //       setShowUserInfo(true);
  //       setIsEditing(true);
  //       setIsOpen(false);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching user details:', error);
  //   }
  // };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: '1000px',
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: '#151517',
    border: '2px solid #000',
    borderRadius: '16px',
    boxShadow: 24,
    p: 4,
    color: 'white'
  };

  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>
      
      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%', backgroundColor: '#151517' },
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {props.menu === 'claimPool' ? (
          <>
            {/* <MenuItem
              onClick={() => {
                props.setSelectedPool(props.id);
                props.setAddFundsModal(true);
              }}
              component={RouterLink}
              to='#'
              sx={{ color: 'text.secondary' }}
            >
              <ListItemIcon>
                <Icon icon={editFill} width={24} height={24} />
              </ListItemIcon>
              <ListItemText
                primary='Add Funds'
                primaryTypographyProps={{ variant: 'body2' }}
              />
            </MenuItem> */}
            <Link
              className='edit-btn' style={{textDecoration: "none", backgroundColor: '#151517'}}
              to={{
                pathname: props.url,
                query: { data: props.id, isCompleted: props.isCompleted },
                params: { data: props.id, isCompleted: props.isCompleted },
              }}
            >
              <MenuItem sx={{ color: 'text.secondary', backgroundColor: '#151517' }}>
                <ListItemIcon>
                  <Icon icon={editFill} width={24} height={24} />
                </ListItemIcon>
                <ListItemText
                  primary='Edit'
                  primaryTypographyProps={{ variant: 'body2' }}
                />
              </MenuItem>
            </Link>
            {/* <MenuItem
              sx={{ color: 'text.secondary' }}
              onClick={() => props.deletePool(props.contractId)}
            >
              <ListItemIcon>
                <Icon icon={trash2Outline} width={24} height={24} />
              </ListItemIcon>
              <ListItemText
                primary='Delete'
                primaryTypographyProps={{ variant: 'body2' }}
              />
            </MenuItem> */}
          </>
        ) : props.menu === 'pools' ? (
          <>
            <MenuItem
              onClick={() => {
                props.setSelectedPool(props.id);
                props.setAddFundsModal(true);
              }}
              component={RouterLink}
              to='#'
              sx={{ color: 'text.secondary', backgroundColor: '#151517' }}
            >
              <ListItemIcon>
                <Icon icon={editFill} width={24} height={24} />
              </ListItemIcon>
              <ListItemText
                primary='Add Funds'
                primaryTypographyProps={{ variant: 'body2' }}
              />
            </MenuItem>
            <Link
              className='edit-btn' style={{textDecoration: "none"}}
              to={{
                pathname: `/dashboard/editPools/${props.contractId}`,
                query: { data: props.contractId },
              }}
            >
              <MenuItem sx={{ color: 'text.secondary', backgroundColor: '#151517' }}>
                <ListItemIcon>
                  <Icon icon={editFill} width={24} height={24} />
                </ListItemIcon>
                <ListItemText
                  primary='Edit'
                  primaryTypographyProps={{ variant: 'body2' }}
                />
              </MenuItem>
            </Link>
            <MenuItem
              sx={{ color: 'text.secondary', backgroundColor: '#151517' }}
              onClick={() => {
                handleDelete();
                setIsOpen(false);
              }}
            >
              <ListItemIcon>
                <Icon icon={trash2Outline} width={24} height={24} />
              </ListItemIcon>
              <ListItemText
                primary='Delete'
                primaryTypographyProps={{ variant: 'body2' }}
              />
            </MenuItem>
          </>
        ) : (
          <>
            <MenuItem 
               component={RouterLink}
              to='#'
              sx={{ color: 'text.secondary', backgroundColor: '#151517' }}
              onClick={handleDelete}
            >
              <ListItemIcon>
                <Icon icon={trash2Outline} width={24} height={24} />
              </ListItemIcon>
              <ListItemText
                primary='Delete'
                primaryTypographyProps={{ variant: 'body2' }}
              />
            </MenuItem>
            <MenuItem
              component={RouterLink}
              to='#'
              sx={{ color: 'text.secondary', backgroundColor: '#151517' }}
              onClick={handleEditClick}
            >
              <ListItemIcon>
                <Icon icon={editFill} width={24} height={24} />
              </ListItemIcon>
              <ListItemText
                primary='Edit'
                primaryTypographyProps={{ variant: 'body2' }}
              />
            </MenuItem>
            <MenuItem
              component={RouterLink}
              to='#'
              sx={{ color: 'text.secondary', backgroundColor: '#151517' }}
              onClick={handleViewDetails}    // Add this onClick handler
            >
              <ListItemIcon>
                <Icon icon={menu2Fill} width={24} height={24} />
              </ListItemIcon>
              <ListItemText
                primary='View Detail'
                primaryTypographyProps={{ variant: 'body2' }}
              />
            </MenuItem>
          </>
        )}
      </Menu>
      
      <Modal
        open={showUserInfo}
        onClose={() => {
          setShowUserInfo(false);
          setIsEditing(false);
        }}
        aria-labelledby="user-info-modal"
      >
        <Box sx={style}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
            <Typography variant="h6" component="h2">
              User Details
            </Typography>
            <IconButton 
              onClick={() => {
                if (isEditing) {
                  handleUpdate();
                } else {
                  setEditedUserInfo({...userInfo}); // Ensure we have a copy of current data
                  setIsEditing(true);
                }
              }}
              sx={{ color: 'white' }}
            >
              <Icon icon={isEditing ? 'mdi:check' : editFill} width={24} height={24} />
            </IconButton>
          </Box>
          {userInfo && (
            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
              {isEditing ? (
                <>
                  <TextField 
                    label="Name" 
                    value={editedUserInfo.name} 
                    onChange={(e) => setEditedUserInfo({...editedUserInfo, name: e.target.value})}
                    sx={{ input: { color: 'white' }, label: { color: 'white' } }}
                  />
                  <TextField 
                    label="Email" 
                    value={editedUserInfo.email}
                    onChange={(e) => setEditedUserInfo({...editedUserInfo, email: e.target.value})}
                    sx={{ input: { color: 'white' }, label: { color: 'white' } }}
                  />
                  <TextField 
                    label="Country" 
                    value={editedUserInfo.country}
                    onChange={(e) => setEditedUserInfo({...editedUserInfo, country: e.target.value})}
                    sx={{ input: { color: 'white' }, label: { color: 'white' } }}
                  />
                  <TextField 
                    label="State" 
                    value={editedUserInfo.state}
                    onChange={(e) => setEditedUserInfo({...editedUserInfo, state: e.target.value})}
                    sx={{ input: { color: 'white' }, label: { color: 'white' } }}
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        checked={editedUserInfo.isActive}
                        onChange={(e) => setEditedUserInfo({...editedUserInfo, isActive: e.target.checked})}
                      />
                    }
                    label="Is Active"
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        checked={editedUserInfo.activeStaker}
                        onChange={(e) => setEditedUserInfo({...editedUserInfo, activeStaker: e.target.checked})}
                      />
                    }
                    label="Active Staker"
                  />
                  <TextField 
                    label="Total Balance" 
                    value={editedUserInfo.totalbalance}
                    onChange={(e) => setEditedUserInfo({...editedUserInfo, totalbalance: e.target.value})}
                    sx={{ input: { color: 'white' }, label: { color: 'white' } }}
                  />
                  <TextField 
                    label="KYC Status" 
                    value={editedUserInfo.kycStatus}
                    onChange={(e) => setEditedUserInfo({...editedUserInfo, kycStatus: e.target.value})}
                    sx={{ input: { color: 'white' }, label: { color: 'white' } }}
                  />
                  <TextField 
                    label="Tier" 
                    value={editedUserInfo.tier}
                    onChange={(e) => setEditedUserInfo({...editedUserInfo, tier: e.target.value})}
                    sx={{ input: { color: 'white' }, label: { color: 'white' } }}
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        checked={editedUserInfo.notifyMe}
                        onChange={(e) => setEditedUserInfo({...editedUserInfo, notifyMe: e.target.checked})}
                      />
                    }
                    label="Notify Me"
                  />
                </>
              ) : (
                <>
                  <Typography>Name: {userInfo.name}</Typography>
                  <Typography>Email: {userInfo.email}</Typography>
                  <Typography>Wallet Address: {userInfo.walletAddress}</Typography>
                  <Typography>Record ID: {userInfo.recordId}</Typography>
                  <Typography>Country: {userInfo.country}</Typography>
                  <Typography>State: {userInfo.state}</Typography>
                  <Typography>KYC Status: {userInfo.kycStatus}</Typography>
                  <Typography>Tier: {userInfo.tier}</Typography>
                  <Typography>Total Balance: {userInfo.totalbalance}</Typography>
                  <Typography>Active Staker: {userInfo.activeStaker ? 'Yes' : 'No'}</Typography>
                  <Typography>Is Active: {userInfo.isActive ? 'Yes' : 'No'}</Typography>
                  <Typography>Profile Picture: {userInfo.profilePics?.profile ? 'Yes' : 'No'}</Typography>
                  <Typography>Cover Picture: {userInfo.profilePics?.cover ? 'Yes' : 'No'}</Typography>
                  <Typography>Notify Me: {userInfo.notifyMe ? 'Yes' : 'No'}</Typography>
                  <Typography>Created At: {new Date(userInfo.createdAt).toLocaleDateString()}</Typography>
                  <Typography>Updated At: {new Date(userInfo.updatedAt).toLocaleDateString()}</Typography>
                </>
              )}
            </Box>
          )}
        </Box>
      </Modal>
    </>
  );
}

